import api from '@/helpers/api.js';

export default {
  async getTheme() {
    return await api.get(`/Theme/Colors`);
  }
};
